/* Two-state nav: transparent over hero, charcoal once scrolled. No libraries. */
(function(){
  var t=8, ticking=false;
  function apply(){
    document.body.classList.toggle('wibaux-scrolled', window.scrollY > t);
    ticking=false;
  }
  function onScroll(){ if(!ticking){ requestAnimationFrame(apply); ticking=true; } }
  document.addEventListener('DOMContentLoaded', apply);
  window.addEventListener('scroll', onScroll, {passive:true});
})();
